module.exports = __webpack_public_path__ + "img/shebei.f240f35f.png";